import styled, { css } from 'styled-components';
import arrowIcon from '../images/right-arrow.svg';

export const GradientButton = styled.button`
  background: linear-gradient(90deg, #0da7fd 0%, #3171ea 100%);
  box-shadow: 0px 0px 17px rgba(103, 146, 210, 0.669116);
  border-radius: 5px;
  border: none;
  color: white;
  height: 54px;
  font-size: 14px;
  font-weight: bold;
  position: relative;
  cursor: pointer;
  ${(props) =>
    props.rightArrow &&
    css`
      &:after {
        content: '';
        background: url(${arrowIcon}) no-repeat center center;
        position: absolute;
        width: 20px;
        height: 20px;
        right: 25px;
        top: 17px; // (54/2 - 10)
      }
    `}
  ${(props) =>
    props.loading &&
    css`
      pointer-events: none;
      opacity: 0.8;
      &:after {
        content: '...';
      }
    `}
  ${(props) => props.disabled && css`
    color: rgba(0,0,0,.25);
    background: #f7f7f7;
    border-color: #d9d9d9;
    pointer-events: none;
    box-shadow: none;
`}
`;
